// Authentication actions
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';

export const SET_USER_DATA_SUCCESS = 'SET_USER_DATA_SUCCESS';
export const SET_USER_DATA_FAIL = 'SET_USER_DATA_FAIL';

// Add new item actions
export const NEW_ITEM_START = 'NEW_ITEM_START';
export const NEW_ITEM_SUCCESS = 'NEW_ITEM_SUCCESS';
export const NEW_ITEM_FAIL = 'NEW_ITEM_FAIL';
export const INIT_ERROR = 'INIT_ERROR';

// Fetched items actions
export const FETCH_DATA_START = 'FETCH_DATA_START';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAIL = 'FETCH_DATA_FAIL';

export const DELETE_ITEM_START = 'DELETE_ITEM_START';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_FAIL = 'DELETE_ITEM_FAIL';

export const SET_ITEM_EDIT_MODE = 'SET_ITEM_EDIT_MODE';
export const UPDATE_ITEM_START = 'UPDATE_ITEM_START';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const UPDATE_ITEM_FAIL = 'UPDATE_ITEM_FAIL';
export const INIT_EDIT_MODE = 'INIT_EDIT_MODE';

// Collections actions
export const NEW_COLLECTION_START = 'NEW_COLLECTION_START';
export const NEW_COLLECTION_SUCCESS = 'NEW_COLLECTION_SUCCESS';
export const NEW_COLLECTION_FAIL = 'NEW_COLLECTION_FAIL';

export const DELETE_COLLECTION_START = 'DELETE_COLLECTION_START';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_FAIL = 'DELETE_COLLECTION_FAIL';

export const ADD_ITEMS_TO_COLLECTION_START = 'ADD_ITEMS_TO_COLLECTION_START';
export const ADD_ITEMS_TO_COLLECTION_SUCCESS = 'ADD_ITEMS_TO_COLLECTION_SUCCESS';
export const ADD_ITEMS_TO_COLLECTION_FAIL = 'ADD_ITEMS_TO_COLLECTION_FAIL';

export const REMOVE_ITEM_FROM_COLLECTION_START = 'REMOVE_ITEM_FROM_COLLECTION_START';
export const REMOVE_ITEM_FROM_COLLECTION_SUCCESS = 'REMOVE_ITEM_FROM_COLLECTION_SUCCESS';
export const REMOVE_ITEM_FROM_COLLECTION_FAIL = 'REMOVE_ITEM_FROM_COLLECTION_FAIL';

export const RENAME_COLLECTION_START = 'RENAME_COLLECTION_START';
export const RENAME_COLLECTION_SUCCESS = 'RENAME_COLLECTION_SUCCESS';
export const RENAME_COLLECTION_FAIL = 'RENAME_COLLECTION_FAIL';



